"use client";

import { useEffect, useRef } from 'react';

interface BlockiesAvatarProps {
  seed: string;
  size?: number;
  scale?: number;
  className?: string;
}

export const BlockiesAvatar = ({ 
  seed, 
  size = 8, 
  scale = 4, 
  className = "" 
}: BlockiesAvatarProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas size
    canvas.width = size * scale;
    canvas.height = size * scale;

    // Simple blockies-like pattern generation
    const hash = seed.split('').reduce((a, b) => {
      a = ((a << 5) - a) + b.charCodeAt(0);
      return a & a;
    }, 0);

    // Generate colors based on hash
    const colors = [
      `hsl(${(hash % 360)}, 70%, 50%)`,
      `hsl(${((hash + 120) % 360)}, 70%, 50%)`,
      `hsl(${((hash + 240) % 360)}, 70%, 50%)`,
      `hsl(${((hash + 60) % 360)}, 70%, 50%)`,
    ];

    // Generate pattern
    for (let i = 0; i < size; i++) {
      for (let j = 0; j < size; j++) {
        const colorIndex = Math.abs(hash + i + j) % colors.length;
        ctx.fillStyle = colors[colorIndex];
        ctx.fillRect(i * scale, j * scale, scale, scale);
      }
    }
  }, [seed, size, scale]);

  return (
    <canvas
      ref={canvasRef}
      className={`rounded-full ${className}`}
      style={{ width: size * scale, height: size * scale }}
    />
  );
};
